import { apiClient } from './client';
import type { ApiResponse, LifecycleEvent, TenantJob, Tenant, Contract } from './types';

export interface ExpiringEntry {
  tenant: Tenant;
  contract: Contract; // snake_case (DbContract)，dashboard.ts 直接透传 findCurrentContract 结果
  daysLeft: number;
}

export interface DailyActivityRow {
  day: string;          // YYYY-MM-DD
  created: number;
  renewed: number;
}

export interface DashboardSummary {
  distribution: Record<string, number>;
  expiring: ExpiringEntry[];
  recentEvents: LifecycleEvent[];
  recentJobs: TenantJob[];          // failed + running，含 tenant_code
  failed24h: number;
  dailyActivity: DailyActivityRow[]; // 7 行
}

export async function getDashboardSummary() {
  const r = await apiClient.get<ApiResponse<DashboardSummary>>('/dashboard/summary');
  return r.data.data!;
}
